export class FavoriteContent {
	Id?: number;
	ClientId: number;
	ContentId: number;
}